import Editor from './base/editor';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend({
  width: 300,
  height: 31,
  keysToTriggerClose: [9, 13, 27],
  classNames: ['is-light-theme', 'composer-anchor-editor'],
  deleteIfPropertyBlank: 'editableObject.href',
  init() {
    this._super(...arguments);
    if (Em.isEmpty(this.get('currentEditableObject.href'))) {
      this.set('autoFocusSelector', 'input:first');
    }
  },
  flushChanges: Em.observer({
    dependentKeys: ['editableObject.href'],
    fn() {
      schedule('afterRender', this, function () {
        if (this.isDestroying) {
          return;
        }
        if (this.triggerDomUpdate) {
          this.triggerDomUpdate();
        }
      });
    },
    sync: true
  })
});